module.exports = __webpack_public_path__ + "img/icon-zertifizierter-shop.90bbfacc.jpg";